import { render, staticRenderFns } from "./WithdrawSuccessModal.vue?vue&type=template&id=2c021598&scoped=true"
import script from "./WithdrawSuccessModal.vue?vue&type=script&lang=js"
export * from "./WithdrawSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawSuccessModal.vue?vue&type=style&index=0&id=2c021598&lang=css"
import style1 from "./WithdrawSuccessModal.vue?vue&type=style&index=1&id=2c021598&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c021598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c021598')) {
      api.createRecord('2c021598', component.options)
    } else {
      api.reload('2c021598', component.options)
    }
    module.hot.accept("./WithdrawSuccessModal.vue?vue&type=template&id=2c021598&scoped=true", function () {
      api.rerender('2c021598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/financials-agent/components/Modal/WithdrawSuccessModal.vue"
export default component.exports